module.exports = __webpack_public_path__ + "static/assets/21fe6f00db4a8f9d56759126ccb460d3.png";